var imported = document.createElement('script');
var generic = generic || {};
var presentAfterpay = presentAfterpay || {};
var priceSelector = '.js-price_installment';
var locale = generic.cookie('LOCALE');
var min = 3500;
var max = 100000;
var apConfig = apConfig || {};

(function ($) {
  imported.src = 'https://static-us.afterpay.com/javascript/present-afterpay.js';
  document.head.appendChild(imported);

  $(window).on('load', function() {
    if (!$('.js-afterpay').length) {
      return;
    }
    var amount = null;
    presentAfterpay.afterpayConfig = function(amount) {
      var quantity = $('.js-quantity').length
        ? $('.js-quantity option:selected').val()
        : 1;
      var currency = window.utag_data ? window.utag_data.currency_code : 'USD';
      $('.afterpay-paragraph').length ? $('.afterpay-paragraph').remove() : '';
      apConfig = {
        priceSelector: priceSelector,
        locale: locale,
        currency: currency,
        showUpperLimit: true,
        amount: amount * quantity,
        minMaxThreshold: {
          min: min,
          max: max,
        },
      };
      if (typeof presentAfterpay === 'function') {
        new presentAfterpay(apConfig).init();
      }
    };
    if ($('.js-price-for-installment').length) {
      amount = $('.js-price-for-installment').has('.on-sale').length
        ? $('.on-sale').html().split('$')[1].replace('.', '')
        : $('.js-price-for-installment').html().split('$')[1].replace('.', '');
    } else if ($('.js-selectBox-label').length) {
      amount = $('.js-selectBox-label option:selected').text().split('$')[1].replace('.', '');
    }
    if (amount !== null) {
      presentAfterpay.afterpayConfig(amount);
    }
  });
})(jQuery);

